import React, { useEffect, useRef, useState } from 'react';

import {
  AccessibilityReadOnly,
  Arrow,
  ContainerMenuItem,
  MenuItem,
  LinkCustom,
  MenuItemLink,
  MenuItemText,
  SubMenuAction,
  SubMenuContainer,
} from './styles';

type SubMenu = Page[];

type Page = {
  name?: string;
  slug?: string[];
  icon?: any;
  key?: string;
  url?: string;
  ariaLabel?: string;
  arialLabel?: string;
  showLink?: boolean;
  subMenu?: SubMenu;
  param?: any;
  type?: string;
  action?: 'chat';
};

type NavbarLinkProps = {
  page: Page;
  isSelected: boolean;
  selected: string;
  Icon: any;
  openSub: string;
  setCloseMenu?: () => void;
};

const NavbarLink = ({
  page,
  isSelected,
  selected,
  openSub,
  setCloseMenu,
  ...rest
}: NavbarLinkProps): JSX.Element => {
  const subMenuRef = useRef(null);
  const [subMenuHeight, setSubMenuHeight] = useState(0);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);

  const Icon = page?.icon;

  useEffect(() => {
    if (openSub) {
      setOpenSubMenu(!!page?.slug?.includes(openSub));
    }
  }, [openSub]);

  useEffect(() => {
    if (subMenuRef && subMenuRef.current) {
      const el = subMenuRef.current;

      // @ts-ignore
      setSubMenuHeight(el.childNodes.length * 53 - 15);
    }
  }, [subMenuRef, page]);

  useEffect(() => {
    if (setCloseMenu) {
      setCloseMenu();
    }
  }, [forceUpdate]);

  const handleOpenChat = (): void => {
    const chatbotButton = document?.querySelector('#hi-custom-widget');
    if (chatbotButton instanceof HTMLElement) {
      chatbotButton.click();
    }
    setForceUpdate(!forceUpdate);
  };

  return (
    <MenuItem {...rest} hidden={!page.showLink}>
      {!page.subMenu && page.showLink && (
        <ContainerMenuItem>
          <LinkCustom
            to={{
              pathname: `/${page.url}`,
              key: page.key,
              state: {
                defaultComponent: page.param,
                defaultType: page.type,
              },
            }}
            onClick={() => setForceUpdate(!forceUpdate)}
          >
            <MenuItemLink className="MenuItem" selected={isSelected}>
              <Icon className="icon-navbar-link align-item-menu" />
              <MenuItemText isSelected={isSelected}>{page.name}</MenuItemText>
              <AccessibilityReadOnly>
                {isSelected ? 'Página atual' : ''}
              </AccessibilityReadOnly>
            </MenuItemLink>
          </LinkCustom>
        </ContainerMenuItem>
      )}
      {page.subMenu && (
        <ContainerMenuItem>
          <MenuItemLink
            className="MenuItem"
            selected={isSelected}
            onClick={() => setOpenSubMenu(!openSubMenu)}
          >
            <Icon className="icon-navbar-link align-item-menu" />
            <MenuItemText isSelected={isSelected}>{page.name}</MenuItemText>
            <Arrow open={openSubMenu} />
          </MenuItemLink>
          <SubMenuContainer
            ref={subMenuRef}
            height={subMenuHeight}
            open={openSubMenu}
          >
            {page.subMenu.map((submenu) => {
              if (!submenu.showLink) {
                return null;
              }

              const isSelectedSub = submenu?.slug?.includes(selected);
              const key = submenu?.slug?.[0] || submenu.name || '';

              if (submenu.action === 'chat') {
                return (
                  <SubMenuAction
                    type="button"
                    aria-label={submenu.ariaLabel || submenu.arialLabel}
                    key={key}
                    onClick={handleOpenChat}
                  >
                    <MenuItemText isSelected={isSelectedSub}>
                      {submenu.name}
                    </MenuItemText>
                  </SubMenuAction>
                );
              }

              return (
                <LinkCustom
                  to={{
                    pathname: `/${submenu.url}`,
                    state: submenu.param ? { view: submenu.param } : undefined,
                  }}
                  aria-label={submenu.ariaLabel || submenu.arialLabel}
                  key={key}
                  onClick={() => setForceUpdate(!forceUpdate)}
                >
                  <MenuItemText isSelected={isSelectedSub}>
                    {submenu.name}
                  </MenuItemText>
                  <AccessibilityReadOnly>
                    {isSelectedSub ? 'Página atual' : ''}
                  </AccessibilityReadOnly>
                </LinkCustom>
              );
            })}
          </SubMenuContainer>
        </ContainerMenuItem>
      )}
    </MenuItem>
  );
};

NavbarLink.defaultProps = {
  setCloseMenu: () => null,
};

export default NavbarLink;
